/**
 * 교육 도메인 공용 어휘 — enum 과 표시 라벨.
 *
 * web(접수 화면)과 admin-web(운영 화면)이 같은 값을 본다. billing-service DB enum 이
 * 원본이라, 앱마다 다시 선언하면 값이 하나 늘 때 한쪽만 조용히 어긋난다.
 * 여기 두는 이유는 admin-web 이 `@platform/billing`(결제 계약·Toss 의존)을
 * 통째로 끌어오지 않고도 이 어휘만 쓸 수 있어야 하기 때문이다.
 */

export type EducationCourseStatus = 'DRAFT' | 'ACTIVE' | 'ARCHIVED';

export type EducationDeliveryMode = 'ONLINE' | 'OFFLINE';

export type EducationSessionStatus =
  | 'DRAFT'
  | 'OPEN'
  | 'CLOSED'
  | 'CANCELED'
  | 'COMPLETED';

export type EducationRegistrationStatus =
  | 'PENDING'
  | 'CONFIRMED'
  | 'CANCELED'
  | 'EXPIRED';

export type EducationAttendanceStatus =
  | 'REGISTERED'
  | 'ATTENDED'
  | 'ABSENT'
  | 'CANCELED';

export const EDUCATION_DELIVERY_MODE_LABEL: Record<
  EducationDeliveryMode,
  string
> = {
  ONLINE: '온라인',
  OFFLINE: '오프라인',
};

export const EDUCATION_REGISTRATION_STATUS_LABEL: Record<
  EducationRegistrationStatus,
  string
> = {
  PENDING: '결제 대기',
  CONFIRMED: '접수 완료',
  CANCELED: '취소',
  EXPIRED: '기한 만료',
};

export const EDUCATION_ATTENDANCE_STATUS_LABEL: Record<
  EducationAttendanceStatus,
  string
> = {
  REGISTERED: '등재',
  ATTENDED: '출석',
  ABSENT: '결석',
  CANCELED: '취소',
};
